import { z } from 'zod';
const productReviewCSVRecordSchema = z.object({
    rating: z
        .string()
        .min(1, 'Rating cannot be empty')
        .transform((val) => {
        const num = Number(val);
        if (isNaN(num)) {
            throw new Error('Rating must be a valid number');
        }
        return num;
    }),
    title: z.string(),
    text: z.string(),
    product_id: z.string().min(1, 'Product ID cannot be empty'),
    user_name: z.string().min(1, 'User name cannot be empty'),
    date_reviewed: z
        .string()
        .min(1)
        .refine((val) => !isNaN(Date.parse(val)), {
        message: 'Invalid date format',
    }),
    image_urls: z
        .string()
        .optional()
        .transform((val) => {
        if (!val)
            return [];
        return val
            .split(',')
            .map((s) => s.trim())
            .filter((s) => s.length > 0);
    }),
});
export { productReviewCSVRecordSchema };
